import styled from '@emotion/styled';
import Box from '../shared/layouts/Box';

const MenuHamburger = styled(Box)((props) => ({
  width: '24px',
  flexShrink: 0,
  cursor: 'pointer',
  '::after, ::before, div': {
    backgroundColor: '#000',
    borderRadius: 3,
    content: "''",
    display: 'block',
    height: '2px',
    margin: '7px 0px',
    transition: 'all .2s ease-in-out',
  },
  '::before': {
    transform: props.menuIsOpen ? 'translateY(9px) rotate(135deg)' : null,
  },

  '::after': {
    transform: props.menuIsOpen ? 'translateY(-9px) rotate(-135deg)' : null,
  },

  div: {
    transform: props.menuIsOpen ? 'scale(0)' : null,
  },
}));

export default MenuHamburger;
